// extracted by mini-css-extract-plugin
export var form = "_be-0";